import { ConfigProvider, Flex, Radio } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { getUserDefaultPlan, setUserDefaultPlan } from "../../utils/defaultPlan";

function UserDropdown({ props }) {
  const { t } = useTranslation();
  const progressBarRef = useRef(null);
  const moduleStatus = useSelector(
    (state) => state.dashboard?.appLayout?.moduleStatus
  );
  const userDefaultPlan = getUserDefaultPlan();

  const [selectedPlan, setSelectedPlan] = useState(props?.defaultPlan);
  const options = [
    { label: 'Old Plan', value: 'old' },
    { label: 'New Plan', value: 'new' },
  ];
  const handlePlanChange = (value) => {
    setSelectedPlan(value);
    setUserDefaultPlan(value);
  }
  const navigate = useNavigate();
  useEffect(() => {
    const strokeDashOffsetValue =
      100 - (props?.productValidity?.packageValidityPercentage ?? 100);
    progressBarRef.current.style.strokeDashoffset = strokeDashOffsetValue;
  }, [props?.productValidity?.packageValidityPercentage]);

  useEffect(() => {
    if (userDefaultPlan) {
      setSelectedPlan(userDefaultPlan);
    } else if (props?.defaultPlan) {
      setSelectedPlan(props?.defaultPlan);
    }
  }, [props?.defaultPlan, userDefaultPlan]);

  return (
    <>
      <aside className="left_sidebar"></aside>
      <div className="rightSide_top_user_dropdown">
        <div className="rightSide_top_user_dropdown_avatar_sec">
          <div className="rightSide_top_user_dropdown_avatar">
            <img
              src={props?.image ? props?.image : "/images/user-profile.png"}
              alt=""
            />
            {moduleStatus?.kyc_status === 1 ? (
              <div className="kyc_vrfd">
                {props?.kycStatus ? (
                  <img src="/images/kyc_vrfd.svg" alt="" />
                ) : (
                  <img src="/images/kyc_not_vrfd.png" alt="" />
                )}
              </div>
            ) : (
              <div className="kyc_vrfd">
                <img src="/images/kyc_vrfd.svg" alt="" />
              </div>
            )}
            <svg
              className="profile_progress"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="-1 -1 34 34"
            >
              <circle
                cx="16"
                cy="16"
                r="15.9155"
                className="progress-bar__background"
              />
              <circle
                cx="16"
                cy="16"
                r="15.9155"
                className="progress-bar__progress js-progress-bar"
                ref={progressBarRef}
              />
            </svg>
          </div>
        </div>
        <div className="rightSide_top_user_dropdown_nameBOx">
          <div className="rightSide_top_user_dropdown_name">
            {props?.fullname}
          </div>
          <div className="rightSide_top_user_dropdown_id">
            {props?.username}
          </div>
          {props?.userExistInNewPlan && props?.userExistInOldPlan &&
            <div className="mt-2 mb-2">

              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: "#954cea", // 👈 your custom primary color
                    controlHeight: 25,       // 🔥 increases height of buttons, inputs, radios, etc.
                    borderRadius: 8,
                    fontSize: 12,
                  },
                }}
              >

                <Flex vertical gap="middle">
                  <Radio.Group
                    onChange={(e) => { handlePlanChange(e?.target?.value) }}
                    // block
                    options={options}
                    defaultValue={selectedPlan}
                    optionType="button"
                    buttonStyle="solid"
                    value={selectedPlan}
                  />
                </Flex>
              </ConfigProvider>
            </div>
          }
          {moduleStatus?.product_status === 1 && (
            <div className="rightSide_top_user_dropdown_package">
              {selectedPlan === "new" ? props?.newPackageName ?? "NA" : props?.packageName ?? "NA"}
            </div>
          )}
        </div>
      </div>
      <div className="top_right_personal_dtl_box_sec">
        <div className="top_right_personal_dtl_box border-sprt">
          <span>{t("personalPV")}</span>
          <strong>{selectedPlan === "new" ? props?.personalPvNewPlan ?? 0 : props?.personalPv ?? 0}</strong>
        </div>
        <div className="top_right_personal_dtl_box">
          <span>{t("groupPV")}</span>
          <strong>{selectedPlan === "new" ? props?.groupPvNewPlan ?? 0 : props?.groupPv ?? 0}</strong>
        </div>
      </div>
      <div className="top_right_personal_dtl_box_sec">
        <div className="top_right_personal_dtl_box text-center">
          <span>{t("sponsor")}</span>
          <strong>{selectedPlan === "new" ? props?.sponsorNameNewPlan : props?.sponsorNameOldPlan}</strong>
        </div>
      </div>

      {(props?.reactivationPair?.status || props?.reactivationPairNew?.status) && <div className="">
        <div className="reactivation_pair">
          <label className="pt-3 top_right_personal_dtl_box text_center mb-2">REACTIVATION PAIR</label>

        </div>

        <>
          {props?.reactivationPair?.status && props?.userExistInOldPlan && selectedPlan === "old" &&
            <div className="top_right_personal_dtl_box_sec tile_shadow">
              <div className="col-4 reactivation_tile" ><div> <span>Achieved</span> </div><div>{props?.reactivationPair?.acheived ?? 0}</div></div>
              <div className="col-4 reactivation_tile" ><div><span>Ceiling</span></div><div>{props?.reactivationPair?.required ?? 0}</div></div>
              <div className="col-4 reactivation_tile" ><div><span>Remaining</span></div><div>{props?.reactivationPair?.pending ?? 0}</div></div>
            </div>}
          {props?.reactivationPairNew?.status && props.userExistInNewPlan && selectedPlan === "new" && <div className="">
            <div className="top_right_personal_dtl_box_sec tile_shadow">
              <div className="col-4 reactivation_tile" ><div> <span>Achieved</span> </div><div>{props?.reactivationPairNew?.acheived ?? 0}</div></div>
              <div className="col-4 reactivation_tile" ><div><span>Ceiling</span></div><div>{props?.reactivationPairNew?.required ?? 0}</div></div>
              <div className="col-4 reactivation_tile" ><div><span>Remaining</span></div><div>{props?.reactivationPairNew?.pending ?? 0}</div></div>
            </div>
          </div>}
        </>
      </div>

      }

      {props?.eligibleForEnrollmentInNewPlan === true && (
        <div className="top_right_personal_dtl_box_sec mt-3">
          <Button onClick={() => navigate("/enroll-users")} className="btn  w-100">
            <i className="fa-solid fa-user-plus"></i> {t("enroll_to_new_plan")}
          </Button>
        </div>
      )}


      <div className="top_profile_upgrade_renew_btn_sec">
        {(moduleStatus?.product_status || moduleStatus?.ecom_status) && (
          <>
            {moduleStatus?.package_upgrade === 1 && (
              <NavLink
                to={{
                  pathname: "/upgrade",
                  search: `?previousPage=${encodeURIComponent("/dashboard")}`
                }}
                className="top_profile_upgrade_renew_btn_1"
              >
                {t("upgrade")}
              </NavLink>
            )}
            {moduleStatus?.subscription_status === 1 && (
              <NavLink
                to={{
                  pathname: "/renew",
                  search: `?previousPage=${encodeURIComponent("/dashboard")}`
                }}
                className="top_profile_upgrade_renew_btn_1">
                {t("renew")}
              </NavLink>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default UserDropdown;
